// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__H7vAh","header":"MessagesList_header__3BX4b","chat":"MessagesList_chat__cfXnk"};